import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultipleTrailerSelection = _resolveComponent("MultipleTrailerSelection")!
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showSelectTrailerPrompt)
      ? (_openBlock(), _createBlock(_component_MultipleTrailerSelection, {
          key: 0,
          trailerOptions: _ctx.attachedTrailers,
          "title-text": "<b>Which trailer are you trying to detach from?</b>",
          onSelect: _ctx.selectTrailer,
          onGoBack: _ctx.displayPreviousModal
        }, null, 8, ["trailerOptions", "onSelect", "onGoBack"]))
      : (_ctx.promptStillNearTrailer)
        ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
            key: 1,
            acceptText: "Yes, go to detach assessment",
            "accept-theme": "primary",
            "reject-theme": "return",
            disabled: _ctx.detachIsLoading,
            "full-screen": true,
            image: _ctx.attachedTrailerCompany,
            rejectText: _ctx.detachIsLoading ? 'Loading' : 'No',
            "rejection-loading": _ctx.detachIsLoading,
            "title-text": `<b>We show you are currently attached, are you still near this trailer?</b>`,
            "subheading-text": _ctx.subheadingMessage,
            "subtitle-text": _ctx.subtitleText,
            "subtitle-style": "strong-subtitle",
            onAccept: _ctx.routeToAssessment,
            onReject: _ctx.displayAssessmentShaming
          }, null, 8, ["disabled", "image", "rejectText", "rejection-loading", "subheading-text", "subtitle-text", "onAccept", "onReject"]))
        : (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
            key: 2,
            acceptText: "Detach Trailer",
            "accept-theme": "primary",
            "reject-theme": "return",
            disabled: _ctx.detachIsLoading,
            "full-screen": true,
            image: _ctx.attachedTrailerCompany,
            rejectText: "Search for Trailers",
            "rejection-loading": _ctx.detachIsLoading,
            "subtitle-text": _ctx.subtitleText,
            "subtitle-style": "strong-subtitle",
            "title-text": `<b>We show you are currently attached.</b>`,
            "subheading-text": _ctx.subheadingMessage,
            onAccept: _ctx.displaySelectTrailerIfNecessary,
            onReject: _ctx.searchForTrailers
          }, null, 8, ["disabled", "image", "rejection-loading", "subtitle-text", "title-text", "subheading-text", "onAccept", "onReject"])),
    (_ctx.showNearTrailer)
      ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
          key: 3,
          acceptText: "Yes",
          "accept-theme": "primary",
          "reject-theme": "return",
          disabled: _ctx.detachIsLoading,
          "full-screen": false,
          rejectText: "No",
          "rejection-loading": _ctx.detachIsLoading,
          "title-text": `<b>Are you still near trailer ${_ctx.attachedTrailerNumber}?</b>`,
          "include-return-deep-link": false,
          onAccept: _ctx.routeToAssessment,
          onReject: _ctx.displayAssessmentShaming
        }, null, 8, ["disabled", "rejection-loading", "title-text", "onAccept", "onReject"]))
      : _createCommentVNode("", true),
    (_ctx.showAssessmentShaming)
      ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
          key: 4,
          acceptText: _ctx.detachIsLoading ? 'Loading' : 'Detach Trailer',
          "accept-theme": "primary",
          "reject-theme": "return",
          disabled: _ctx.detachIsLoading,
          "full-screen": false,
          rejectText: "Go Back",
          "confirmation-loading": _ctx.detachIsLoading,
          "title-text": `<b>Detach without assessment?</b><br /><span style='font-size: 15px; font-family: Open Sans'>Please make sure to assess your trailer before detaching next time. Accurate info keeps our trailers available and rolling.</span>`,
          "include-return-deep-link": false,
          onAccept: _ctx.removeAttachedTrailer,
          onReject: _ctx.displayPreviousModal
        }, null, 8, ["acceptText", "disabled", "confirmation-loading", "title-text", "onAccept", "onReject"]))
      : _createCommentVNode("", true),
    (_ctx.showDetachAllPrompt)
      ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
          key: 5,
          acceptText: _ctx.detachIsLoading ? 'Loading' : 'Detach All Trailers',
          "accept-theme": "primary",
          "reject-theme": "return",
          disabled: _ctx.detachIsLoading,
          "full-screen": false,
          rejectText: "Go Back",
          "confirmation-loading": _ctx.detachIsLoading,
          "title-text": `<b>Detach all?</b><br /><span style='font-size: 15px; font-family: Open Sans'>Our system has you attached to multiple trailers. We'll go ahead and detach you from all of them.</span>`,
          "include-return-deep-link": false,
          onAccept: _ctx.removeAttachedTrailer,
          onReject: _ctx.displayPreviousModal
        }, null, 8, ["acceptText", "disabled", "confirmation-loading", "title-text", "onAccept", "onReject"]))
      : _createCommentVNode("", true)
  ], 64))
}